<app-header>
  <a class="logo-el" [routerLink]="'/'">
    <img src="/assets/picflow-icon.svg" alt="" width="32" height="32" />
    <span>Picflow</span>
  </a>
  <div class="spacer"></div>
  <div class="header-buttons" *onlyForScreens="['desktop']">
    <a
      [routerLink]="'/auth/login'"
      appButton
      name="login"
      location="subscribe-to-asset-page"
      weight="bold"
      color="hard-simple"
      >Log in</a
    >
    <a
      [routerLink]="'/auth/signup'"
      appButton
      name="signup"
      location="subscribe-to-asset-page"
      color="primary"
      weight="bold"
      >Sign up Free</a
    >
  </div>
</app-header>
@if (asset$ | async; as asset) {
<div class="page">
  <div class="asset-container">
    <img [src]="asset | assetUrl : asset.version_data.watermark_uuid : 160 | async" alt="" class="asset" />
    <div class="icon">
      <app-svg src="/assets/icons/check-circle.svg"></app-svg>
    </div>
  </div>
  <h1>Resubscribed!</h1>
  <p>
    You’re now subscribed again and you’ll get new updates for the asset
    <b>{{ asset.version_data.asset_name }}</b> going forward.
  </p>
  <a
    appButton
    name="view-gallery"
    location="subscribe-to-asset-page"
    color="primary"
    size="3"
    height="4"
    spacing="5"
    [routerLink]="'/gallery/' + gallery.id + '/feedback'"
    [center]="true"
    >View Gallery</a
  >
</div>
}
